import { b as f, k as t, i as h } from "./color-scale-utils-38aedd61.mjs";
function i(a, e) {
  return a && f(a, e, t);
}
function k(a, e) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!h(r))
      return a(r, n);
    for (var u = r.length, s = e ? u : -1, b = Object(r); (e ? s-- : ++s < u) && n(b[s], s, b) !== !1; )
      ;
    return r;
  };
}
var E = k(i);
const v = E;
export {
  v as b
};
//# sourceMappingURL=_baseEach-81f85d61.mjs.map
